export default {
  SET_INDUSTRIES: (state, industries) => (state.industries = industries),
}
